/* CP Kategorieseite — Filterlogik zur Section cp-category.
   Konfiguration kommt ausschließlich über data-Attribute im Markup. */
(function(){
  var root = document.querySelector('[data-cpk]');
  if(!root || root.dataset.cpkReady) return;
  root.dataset.cpkReady = '1';

  var DATA = { p: [] };
  try {
    DATA = JSON.parse(root.querySelector('[data-cpk-data]').textContent);
  } catch(e){
    if(window.console) console.warn('[cp-category] Produktdaten nicht lesbar:', e);
  }
  if(!DATA || !DATA.p) DATA = { p: [] };

  var grid    = root.querySelector('[data-cpk-grid]');
  var cards   = Array.prototype.slice.call(root.querySelectorAll('[data-cpk-card]'));
  var groups  = Array.prototype.slice.call(root.querySelectorAll('[data-cpk-group]'));
  var chipBox = root.querySelector('[data-cpk-chips]');
  var foundEl = root.querySelector('[data-cpk-found]');
  var headEl  = root.querySelector('[data-cpk-headcount]');
  var emptyEl = root.querySelector('[data-cpk-empty]');
  var resetEl = root.querySelector('[data-cpk-reset]');
  var fcountEl= root.querySelector('[data-cpk-fcount]');
  var vehBox  = root.querySelector('[data-cpk-veh]');
  var sideVeh = root.querySelector('[data-cpk-sideveh]');

  var byHandle = {};
  for(var i=0;i<DATA.p.length;i++) byHandle[DATA.p[i].h] = DATA.p[i];

  var OPT_SIZE  = root.dataset.sizeOption  || 'Größe';
  var OPT_COLOR = root.dataset.colorOption || 'Farbe';

  var state = { veh:null, sel:{}, avail:false, sort:'', cols:null };
  var FIT = null, FITSKU = null, FITROWS = null;
  var STORE = 'cp:fahrzeug';
  var H = window.CPFitment || null;

  // Die Filtergruppe, die die Farboption 1:1 abbildet (nicht Zoll/Lochkreis-Ableitungen)
  var colorGroup = null;
  groups.forEach(function(g){
    if(g.dataset.kind === 'option' && g.dataset.option === OPT_COLOR &&
       (!g.dataset.extract || g.dataset.extract === 'full')) colorGroup = g;
  });

  // Marken-Tags (marke:audi) — Gruppe, Präfix, Seite einer Markenkollektion
  var BRAND_PREFIX = root.dataset.brandPrefix || 'marke:';
  var PAGE_BRAND   = root.dataset.pageBrand || '';
  var STRIP        = root.dataset.strip || '';
  var SPLIT_AT     = root.dataset.splitAt || '';
  var HIDE_SINGLE  = root.dataset.hideSingle === '1';
  var brandGroup = null;
  groups.forEach(function(g){ if(g.dataset.kind === 'tag' && g.dataset.prefix === BRAND_PREFIX) brandGroup = g; });
  var vehMode = vehBox ? (vehBox.dataset.source || 'fitment') : 'fitment';
  var loading = false;
  var LOAD_TOTAL = 0;
  function fmtNum(n){ try { return Number(n).toLocaleString('de-DE'); } catch(e){ return String(n); } }

  // Anzeigename eines Tag-Werts: Kollektion mit gleichem Handle, sonst der Wert selbst
  // Anzeigename eines Tag-Werts: eigene Beschriftung am Block, sonst gleichnamige
  // Kollektion (z. B. marke:audi -> "Audi"), sonst der Wert selbst.
  function tagLabel(t, g){
    if(g){
      if(!g.__labels) g.__labels = parseSwatches(g.dataset.labels);
      var own = g.__labels[String(t).toLowerCase()];
      if(own) return own;
    }
    if(DATA.cm && DATA.cm[t]) return DATA.cm[t];
    return t;
  }

  /* ---------- kleine Helfer (fallen auf eigene Kopien zurück, falls das Asset fehlt) ---------- */
  function slug(s){
    if(H) return H.slug(s);
    return String(s).replace(/Š/g,'S').replace(/š/g,'s').replace(/ß/g,'ss')
      .normalize('NFKD').replace(/[̀-ͯ]/g,'')
      .replace(/[^A-Za-z0-9]+/g,'-').replace(/^-|-$/g,'').toLowerCase();
  }
  function inchOf(l){ if(H) return H.inch(l); var m=/x(\d{2})/.exec(l||''); return m?m[1]:''; }
  function boltOf(l){ if(H) return H.bolt(l); var p=String(l||'').split('·'); return p.length>1?p[p.length-1].trim():''; }
  function money(c){
    if(H) return H.formatPrice(c);
    return (c/100).toFixed(2).replace('.',',') + ' €';
  }
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function sortSize(a,b){
    if(H) return H.sortLabel(a,b);
    return String(a).localeCompare(String(b),'de',{numeric:true});
  }

  /* ---------- Werte einer Filtergruppe aus einer Variante lesen ---------- */
  function valueOf(g, prod, variant){
    var kind = g.dataset.kind;
    if(kind === 'option'){
      var idx = prod.on.indexOf(g.dataset.option);
      if(idx < 0) return null;
      var raw = variant[0][idx];
      if(raw == null) return null;
      if(g.dataset.extract === 'inch') return inchOf(raw);
      if(g.dataset.extract === 'bolt') return boltOf(raw);
      return raw;
    }
    if(kind === 'price'){
      var steps = priceSteps(g);
      for(var s=0;s<steps.length;s++) if(variant[1] < steps[s].max) return steps[s].id;
      return steps.length ? steps[steps.length-1].id : null;
    }
    return null;
  }

  function priceSteps(g){
    if(g.__steps) return g.__steps;
    var raw = (g.dataset.steps || '').split(',').map(function(x){ return parseInt(x,10); })
      .filter(function(x){ return !isNaN(x); });
    var out = [], prev = 0;
    for(var i=0;i<raw.length;i++){
      out.push({ id:'bis-'+raw[i], max:raw[i]*100,
                 label:(prev ? money(prev*100)+' – '+money(raw[i]*100) : 'bis '+money(raw[i]*100)) });
      prev = raw[i];
    }
    out.push({ id:'ab-'+prev, max:Infinity, label:'ab '+money(prev*100) });
    g.__steps = out;
    return out;
  }

  /* ---------- Tag-Gruppe: Werte hängen am Produkt, nicht an der Variante ---------- */
  function tagValues(g, prod){
    var pre = g.dataset.prefix || '', suf = g.dataset.suffix || '', out = [];
    for(var i=0;i<prod.tg.length;i++){
      var t = prod.tg[i];
      if(pre && t.indexOf(pre) === 0) out.push(t.slice(pre.length));
      else if(suf && t.length > suf.length && t.slice(-suf.length) === suf) out.push(t.slice(0, -suf.length));
    }
    return out;
  }

  /* ---------- Varianten eines Produkts nach aktueller Auswahl ---------- */
  function survivors(prod, skipKey){
    var vs = prod.v;
    var out = [];
    for(var i=0;i<vs.length;i++){
      var v = vs[i];
      if(state.veh && FITSKU && !FITSKU[v[4]]) continue;
      if(state.avail && !v[2] && skipKey !== 'lager') continue;
      var ok = true;
      for(var g=0; g<groups.length && ok; g++){
        var grp = groups[g], key = grp.dataset.key, kind = grp.dataset.kind;
        if(kind === 'avail' || key === skipKey) continue;
        var chosen = state.sel[key];
        if(!chosen || !chosen.length) continue;
        if(kind === 'tag'){
          var tv = tagValues(grp, prod), hit = false;
          for(var t=0;t<tv.length && !hit;t++) if(chosen.indexOf(slug(tv[t])) > -1) hit = true;
          ok = hit;
        } else {
          var val = valueOf(grp, prod, v);
          ok = val != null && chosen.indexOf(slug(val)) > -1;
        }
      }
      if(ok) out.push(v);
    }
    return out;
  }

  /* ---------- Facettenwerte einmalig aufbauen ---------- */
  function buildValues(){
    groups.forEach(function(g){
      var kind = g.dataset.kind;
      if(kind === 'avail') return;
      var box = g.querySelector('[data-cpk-values]');
      if(!box) return;
      var vals = [], seen = {};

      if(kind === 'price'){
        priceSteps(g).forEach(function(s){ vals.push({ v:s.id, label:s.label }); });
      } else {
        DATA.p.forEach(function(prod){
          if(kind === 'tag'){
            tagValues(g, prod).forEach(function(t){
              if(!seen[t]){ seen[t] = 1; vals.push({ v:slug(t), label:tagLabel(t, g) }); }
            });
          } else {
            prod.v.forEach(function(v){
              var raw = valueOf(g, prod, v);
              if(raw == null || raw === '' || seen[raw]) return;
              seen[raw] = 1;
              vals.push({ v:slug(raw), label:raw });
            });
          }
        });
        if(g.dataset.sort === 'size') vals.sort(function(a,b){ return sortSize(a.label,b.label); });
        else if(g.dataset.sort === 'num') vals.sort(function(a,b){ return parseFloat(a.label) - parseFloat(b.label); });
        else vals.sort(function(a,b){ return String(a.label).localeCompare(String(b.label),'de',{numeric:true}); });
      }

      var swatches = parseSwatches(g.dataset.swatches);
      box.innerHTML = vals.map(function(o){
        var sw = swatches[o.label.toLowerCase()];
        return '<button type="button" class="cpk__val" data-v="'+esc(o.v)+'" aria-pressed="false">'+
          (sw ? '<span class="cpk__swatch" style="background:'+esc(sw)+'"></span>'
              : '<span class="cpk__box"></span>')+
          '<span>'+esc(o.label)+'</span><span class="cpk__vnum" data-n></span></button>';
      }).join('');
      g.__vals = vals;
      // Gruppen mit nur einem Wert sagen nichts aus (z. B. „Audi“ auf der Audi-Seite)
      if(HIDE_SINGLE && kind !== 'price'){
        var single = vals.length <= 1;
        g.dataset.single = single ? '1' : '';
        if(single) g.hidden = true;
        else if(!(state.veh && g.dataset.hideWithVehicle === 'true')) g.hidden = false;
      }
    });
  }

  function parseSwatches(raw){
    var map = {};
    (raw || '').split(',').forEach(function(pair){
      var p = pair.split(':');
      if(p.length === 2) map[p[0].trim().toLowerCase()] = p[1].trim();
    });
    return map;
  }

  /* ---------- Zählerstände je Facettenwert ---------- */
  function updateCounts(){
    groups.forEach(function(g){
      if(g.dataset.kind === 'avail' || !g.__vals) return;
      var key = g.dataset.key;
      var counts = {};
      DATA.p.forEach(function(prod){
        var vs = survivors(prod, key);
        if(!vs.length) return;
        if(g.dataset.kind === 'tag'){
          tagValues(g, prod).forEach(function(t){ counts[slug(t)] = (counts[slug(t)]||0) + 1; });
        } else {
          var seen = {};
          vs.forEach(function(v){
            var raw = valueOf(g, prod, v);
            if(raw == null || raw === '') return;
            var s = slug(raw);
            if(seen[s]) return;
            seen[s] = 1;
            counts[s] = (counts[s]||0) + 1;
          });
        }
      });
      Array.prototype.forEach.call(g.querySelectorAll('.cpk__val'), function(btn){
        var n = counts[btn.dataset.v] || 0;
        var numEl = btn.querySelector('[data-n]');
        if(numEl) numEl.textContent = n;
        var on = (state.sel[key] || []).indexOf(btn.dataset.v) > -1;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-disabled', (n === 0 && !on) ? 'true' : 'false');
      });
    });
  }

  /* ---------- Karten aktualisieren ---------- */
  function apply(){
    // Ohne Produktdaten wird nicht gefiltert: lieber alles zeigen als einen leeren Shop.
    if(!DATA.p.length){
      cards.forEach(function(c){ c.hidden = false; });
      if(cards.length){
        if(foundEl) foundEl.innerHTML = '<b>' + cards.length + '</b> ' + (cards.length === 1 ? 'Modell' : 'Modelle');
        if(headEl)  headEl.textContent = cards.length + (cards.length === 1 ? ' Modell' : ' Modelle');
      }
      if(emptyEl) emptyEl.hidden = cards.length > 0;
      if(grid)    grid.hidden = false;
      capCards();
      return;
    }

    var shown = 0, sizeTotal = 0;
    var order = [];

    cards.forEach(function(card){
      var prod = byHandle[card.dataset.handle];
      if(!prod){ card.hidden = true; return; }
      if(PMODEL && modelKeyOf(prod) !== PMODEL){ card.hidden = true; return; }
      var vs = survivors(prod, null);
      var visible = vs.length > 0;
      card.hidden = !visible;
      if(!visible) return;
      shown++;

      var minPrice = Infinity, inches = {}, bolts = {}, colors = {}, labels = {};
      var soldOut = true;
      for(var sv=0; sv<prod.v.length; sv++){ if(prod.v[sv][2]){ soldOut = false; break; } }
      vs.forEach(function(v){
        if(v[1] < minPrice) minPrice = v[1];
        var sizeIdx = prod.on.indexOf(OPT_SIZE);
        var colorIdx = prod.on.indexOf(OPT_COLOR);
        var sz = sizeIdx > -1 ? v[0][sizeIdx] : '';
        if(sz){
          labels[sz] = 1;
          var inch = inchOf(sz); if(inch) inches[inch] = 1;
          var bolt = boltOf(sz); if(bolt) bolts[bolt] = 1;
        }
        if(colorIdx > -1 && v[0][colorIdx]) colors[v[0][colorIdx]] = 1;
      });
      sizeTotal += Object.keys(labels).length;

      var priceEl = card.querySelector('[data-cpk-price]');
      if(priceEl && minPrice < Infinity){
        // CP Aktion: Rabatt in Prozent aus data-promo, Normalpreis durchgestrichen
        var promo = parseFloat(card.getAttribute('data-promo')) || 0;
        priceEl.textContent = money(promo > 0 ? minPrice - Math.round(minPrice * promo / 100) : minPrice);
        var oldEl = card.querySelector('[data-cpk-old]');
        if(oldEl) oldEl.textContent = money(minPrice);
      }

      var inchList = Object.keys(inches).sort(function(a,b){ return a-b; });
      var boltList = Object.keys(bolts);
      var spec = [];
      if(inchList.length) spec.push(inchList.length > 1 ? inchList[0]+'″–'+inchList[inchList.length-1]+'″' : inchList[0]+'″');
      if(boltList.length) spec.push(boltList.length > 2 ? boltList.length + ' Lochkreise' : boltList.join(' · '));
      var specEl = card.querySelector('[data-cpk-spec]');
      if(specEl && !specEl.dataset.static) specEl.textContent = spec.join('  ·  ');

      // Welche Variante die Karte zeigt und verlinkt: gewählte Farbe (Filter oder Farbfeld),
      // sonst die Standardfarbe; lieferbare Größe bevorzugt, bei Fahrzeug nur freigegebene.
      var ci = prod.on.indexOf(OPT_COLOR);
      var want = (card.__color && colors[card.__color]) ? card.__color : null;
      var colorSel = colorGroup ? (state.sel[colorGroup.dataset.key] || []) : [];
      var target = (want || colorSel.length || state.veh || activeCount() > 0)
        ? pickVariant(prod, vs, ci, want) : null;
      var shownColor = setCardVariant(card, prod, target, ci);

      var dotsEl = card.querySelector('[data-cpk-dots]');
      if(dotsEl){
        var sw = swatchMap();
        dotsEl.innerHTML = Object.keys(colors).map(function(c){
          var on = c === shownColor;
          return '<button type="button" class="cpk__dot'+(on ? ' is-on' : '')+'" data-cpk-color="'+esc(c)+'"'+
            ' title="'+esc(c)+'" aria-label="'+esc(c)+'" aria-pressed="'+(on ? 'true' : 'false')+'"'+
            ' style="background:'+esc(sw[c.toLowerCase()] || '#3a3a3a')+'"></button>';
        }).join('');
      }

      var fitEl = card.querySelector('[data-cpk-fit]');
      if(fitEl){
        if(state.veh){
          var all = {};
          prod.v.forEach(function(v){
            var si = prod.on.indexOf(OPT_SIZE);
            if(si > -1 && v[0][si]) all[v[0][si]] = 1;
          });
          fitEl.textContent = Object.keys(labels).length + ' von ' + Object.keys(all).length + ' Größen passen';
          fitEl.hidden = false;
        } else {
          fitEl.hidden = true;
        }
      }

      var badge = card.querySelector('[data-cpk-fitbadge]');
      if(badge) badge.hidden = !(FIT && !state.veh && noRelease(prod.h));

      order.push({ card:card, price:minPrice, title:prod.t,
                   inch: inchList.length ? parseInt(inchList[inchList.length-1],10) : 0,
                   idx: parseInt(card.dataset.idx,10),
                   sold: soldOut ? 1 : 0 });
    });

    sortCards(order);
    updateCounts();
    renderChips();

    // Während im Hintergrund nachgeladen wird: ohne Filter gleich die Gesamtzahl zeigen statt hochzuzählen
    var fullCount = loading && LOAD_TOTAL > shown && activeCount() === 0 && !state.veh && !PMODEL;
    if(fullCount){ shown = LOAD_TOTAL; sizeTotal = 0; }
    if(foundEl){
      foundEl.innerHTML = '<b>' + fmtNum(shown) + '</b> ' + (shown === 1 ? 'Modell' : 'Modelle') +
        (sizeTotal ? ' · ' + sizeTotal + ' ' + (sizeTotal === 1 ? 'Größe' : 'Größen') : '');
    }
    if(headEl) headEl.textContent = fmtNum(shown) + (shown === 1 ? ' Modell' : ' Modelle');
    if(emptyEl) emptyEl.hidden = shown > 0;
    if(grid) grid.hidden = shown === 0;

    var active = activeCount();
    if(resetEl) resetEl.hidden = active === 0 && !state.veh;
    if(fcountEl){ fcountEl.textContent = active; fcountEl.hidden = active === 0; }
    syncBrandSelect();
    capCards();
  }

  // Produkt-Modus: Marken-Dropdown folgt dem Marken-Filter (Chip/Seitenspalte) und umgekehrt
  function syncBrandSelect(){
    if(vehMode !== 'products' || !brandGroup || PAGE_BRAND) return;
    var bs = root.querySelector('[data-cpk-brand]');
    if(!bs) return;
    var sel = state.sel[brandGroup.dataset.key] || [];
    var want = sel.length === 1 ? sel[0] : '';
    if(bs.value !== want){
      bs.value = want;
      if(bs.value !== want) bs.value = '';
      fillModels(bs.value);
    }
  }

  function noRelease(handle){
    if(!FIT) return false;
    for(var i=0;i<FIT.p.length;i++) if(FIT.p[i][0] === handle){
      for(var v=0;v<FIT.v.length;v++) if(FIT.v[v][3] === i) return false;
      return true;
    }
    return true;
  }

  /* ---------- Variante je Karte: Bild + Link ---------- */
  // Farbe des Hauptbilds: die erste Variante, deren Bild das Produktbild 0 ist
  function defaultColor(prod, ci){
    if(ci < 0) return null;
    for(var i=0;i<prod.v.length;i++) if(prod.v[i][5] === 0) return prod.v[i][0][ci];
    return prod.v.length ? prod.v[0][0][ci] : null;
  }

  function pickVariant(prod, vs, ci, want){
    if(!vs.length) return null;
    var pref = want || defaultColor(prod, ci), cand = [];
    if(pref && ci > -1) cand = vs.filter(function(v){ return v[0][ci] === pref; });
    if(!cand.length) cand = vs;
    for(var i=0;i<cand.length;i++) if(cand[i][2]) return cand[i];
    return cand[0];
  }

  // Aus der 600px-URL ein srcset für kleinere Kacheln ableiten
  function srcsetOf(url){
    if(url.indexOf('width=600') < 0) return '';
    return [300,450,600].map(function(w){ return url.replace('width=600', 'width='+w) + ' ' + w + 'w'; }).join(', ');
  }

  // Setzt Bild und Links der Karte auf die Variante; ohne Variante zurück auf den Standard.
  // Rückgabe: die angezeigte Farbe (für die Markierung im Farbfeld).
  function setCardVariant(card, prod, v, ci){
    var img = card.querySelector('.cpk__cimg img');
    var links = card.querySelectorAll('.cpk__cimg, .cpk__ctitle a');
    var base = card.dataset.url || prod.u || '';
    if(img && img.dataset.src0 == null){
      img.dataset.src0 = img.getAttribute('src') || '';
      img.dataset.srcset0 = img.getAttribute('srcset') || '';
    }
    var url = (v && prod.im && v[5] >= 0) ? prod.im[v[5]] : null;
    if(img){
      var cur = img.getAttribute('src');
      if(url && url !== img.dataset.src0){
        if(cur !== url){ img.setAttribute('srcset', srcsetOf(url)); img.setAttribute('src', url); }
      } else if(cur !== img.dataset.src0){
        if(img.dataset.srcset0) img.setAttribute('srcset', img.dataset.srcset0); else img.removeAttribute('srcset');
        img.setAttribute('src', img.dataset.src0);
      }
    }
    var href = v ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v[3] : base;
    if(base) Array.prototype.forEach.call(links, function(a){ a.setAttribute('href', href); });
    if(v && ci > -1) return v[0][ci];
    return defaultColor(prod, ci);
  }

  var _sw = null;
  function swatchMap(){
    if(_sw) return _sw;
    _sw = {};
    groups.forEach(function(g){
      if(g.dataset.swatches) Object.assign(_sw, parseSwatches(g.dataset.swatches));
    });
    return _sw;
  }

  function sortCards(list){
    var mode = state.sort;
    list.sort(function(a,b){
      if(a.sold !== b.sold) return a.sold - b.sold;
      if(mode === 'price-asc')  return a.price - b.price;
      if(mode === 'price-desc') return b.price - a.price;
      if(mode === 'title-asc')  return a.title.localeCompare(b.title,'de');
      if(mode === 'inch-desc')  return b.inch - a.inch;
      return a.idx - b.idx;
    });
    list.forEach(function(o){ grid.appendChild(o.card); });
  }

  function activeCount(){
    var n = 0;
    for(var k in state.sel) n += (state.sel[k] || []).length;
    if(state.avail) n++;
    return n;
  }

  function renderChips(){
    if(!chipBox) return;
    var html = '';
    groups.forEach(function(g){
      var key = g.dataset.key, chosen = state.sel[key] || [];
      if(!chosen.length || !g.__vals) return;
      chosen.forEach(function(v){
        var hit = g.__vals.filter(function(o){ return o.v === v; })[0];
        html += '<button type="button" class="cpk__chip" data-chip data-key="'+esc(key)+'" data-v="'+esc(v)+'">'+
          esc(hit ? hit.label : v)+'<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
      });
    });
    if(state.avail){
      html += '<button type="button" class="cpk__chip" data-chip data-key="lager">Nur Lieferbares'+
        '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    }
    chipBox.innerHTML = html;
  }

  /* ---------- URL ---------- */
  function readUrl(){
    var q = new URLSearchParams(window.location.search);
    groups.forEach(function(g){
      var key = g.dataset.key;
      if(g.dataset.kind === 'avail') return;
      var raw = q.get(key);
      state.sel[key] = raw ? raw.split(',').filter(Boolean) : [];
    });
    state.avail = q.get('lager') === '1';
    state.sort  = q.get('sort') || '';
    var sortSel = root.querySelector('[data-cpk-sort]');
    if(sortSel) sortSel.value = state.sort;
    var av = root.querySelector('[data-cpk-avail]');
    if(av) av.setAttribute('aria-pressed', state.avail ? 'true' : 'false');
    return { marke:q.get('marke'), modell:q.get('modell') };
  }

  function writeUrl(push){
    if(!window.history || !window.history.replaceState) return;
    var u = new URL(window.location.href);
    var p = u.searchParams;
    ['marke','modell','lager','sort'].forEach(function(k){ p.delete(k); });
    groups.forEach(function(g){ p.delete(g.dataset.key); });
    groups.forEach(function(g){
      var key = g.dataset.key, chosen = state.sel[key] || [];
      if(chosen.length) p.set(key, chosen.join(','));
    });
    if(state.avail) p.set('lager','1');
    if(state.sort)  p.set('sort', state.sort);
    if(state.veh){ p.set('marke', slug(state.veh.brand)); p.set('modell', slug(state.veh.model)); }
    if(PMODEL){ if(PBRAND) p.set('marke', PBRAND); p.set('modell', PMODEL); }
    var url = u.pathname + (p.toString() ? '?' + p.toString() : '');
    if(push) window.history.pushState({}, '', url); else window.history.replaceState({}, '', url);
  }

  /* ---------- Fahrzeug ---------- */
  function setVehicle(brand, model, push){
    if(!FIT) return;
    state.veh = { brand:brand, model:model };
    var rel = H ? H.release(FIT, brand, model) : null;
    FITSKU = rel ? rel.skus : null;
    FITROWS = rel ? rel.rows : [];

    // Filter, die mit dem neuen Fahrzeug leer laufen, entfernen — aber sichtbar
    var dropped = [];
    groups.forEach(function(g){
      var key = g.dataset.key, chosen = state.sel[key] || [];
      if(!chosen.length) return;
      var keep = chosen.filter(function(v){
        var any = false;
        DATA.p.forEach(function(prod){
          if(any) return;
          var saved = state.sel[key];
          state.sel[key] = [v];
          if(survivors(prod, null).length) any = true;
          state.sel[key] = saved;
        });
        return any;
      });
      if(keep.length !== chosen.length){
        var lost = chosen.filter(function(v){ return keep.indexOf(v) < 0; });
        lost.forEach(function(v){
          var hit = (g.__vals || []).filter(function(o){ return o.v === v; })[0];
          dropped.push(hit ? hit.label : v);
        });
        state.sel[key] = keep;
      }
    });

    // Lochkreis-Gruppe bei gewähltem Fahrzeug ausblenden — ein Auto hat genau einen
    groups.forEach(function(g){
      if(g.dataset.hideWithVehicle === 'true') g.hidden = true;
    });

    var boltList = {};
    if(FITSKU){
      DATA.p.forEach(function(prod){
        var si = prod.on.indexOf('Größe');
        prod.v.forEach(function(v){
          if(FITSKU[v[4]] && si > -1){ var b = boltOf(v[0][si]); if(b) boltList[b] = 1; }
        });
      });
    }

    var name = brand + ' ' + model;
    var years = FITROWS && FITROWS.length
      ? FITROWS.map(function(r){ return (r.gen ? r.gen : '') + (r.years ? ' ' + r.years : ''); }).join(' · ').trim()
      : '';
    var bolts = Object.keys(boltList);
    var meta = (bolts.length ? 'Lochkreis ' + bolts.join(' / ') : '') + (years ? (bolts.length ? ' · ' : '') + years : '');

    show('[data-cpk-vehpick]', false); show('[data-cpk-vehmemo]', false); show('[data-cpk-vehon]', true);
    setText('[data-cpk-vehname]', name);
    setText('[data-cpk-vehmeta]', meta);
    if(sideVeh){ sideVeh.hidden = false; setText('[data-cpk-sidevehname]', name); setText('[data-cpk-sidevehmeta]', meta); }

    var note = root.querySelector('[data-cpk-vehnote]');
    if(note){
      if(dropped.length){
        note.innerHTML = esc(dropped.join(', ')) + ' passt nicht zu diesem Fahrzeug — Filter entfernt.';
        note.hidden = false;
      } else { note.hidden = true; }
    }

    try { localStorage.setItem(STORE, JSON.stringify({ v:1, marke:brand, modell:model, ts:Date.now() })); } catch(e){}
    writeUrl(push !== false);
    apply();
  }

  function clearVehicle(forget){
    state.veh = null; FITSKU = null; FITROWS = null;
    groups.forEach(function(g){ if(g.dataset.hideWithVehicle === 'true') g.hidden = (g.dataset.single === '1'); });
    show('[data-cpk-vehon]', false); show('[data-cpk-vehmemo]', false); show('[data-cpk-vehpick]', true);
    var note = root.querySelector('[data-cpk-vehnote]'); if(note) note.hidden = true;
    if(sideVeh) sideVeh.hidden = true;
    if(forget){ try { localStorage.removeItem(STORE); } catch(e){} }
    writeUrl(true);
    apply();
  }

  function show(sel, on){ var el = root.querySelector(sel); if(el) el.hidden = !on; }
  function setText(sel, txt){ var el = root.querySelector(sel); if(el) el.textContent = txt; }

  function fillBrands(){
    var bs = root.querySelector('[data-cpk-brand]'), ms = root.querySelector('[data-cpk-model]');
    if(!bs || !FIT) return;
    var names = Object.keys(FIT.f).sort(function(a,b){ return a.localeCompare(b,'de'); });
    bs.innerHTML = '<option value="">Marke wählen</option>' + names.map(function(n){
      return '<option value="'+esc(n)+'">'+esc(n)+'</option>';
    }).join('');
    bs.addEventListener('change', function(){
      var b = bs.value;
      if(!b){ ms.innerHTML = '<option value="">Modell wählen</option>'; ms.disabled = true; toggleGo(); return; }
      var models = Object.keys(FIT.f[b]).sort(function(a,b2){ return a.localeCompare(b2,'de',{numeric:true}); });
      ms.innerHTML = '<option value="">Modell wählen</option>' + models.map(function(m){
        return '<option value="'+esc(m)+'">'+esc(m)+'</option>';
      }).join('');
      ms.disabled = false;
      toggleGo();
    });
    ms.addEventListener('change', toggleGo);
  }

  /* ---------- Fahrzeug-Band im Produkt-Modus: Marke aus Tags, Modell = Produkt ---------- */
  function capWord(s){ return String(s).charAt(0).toUpperCase() + String(s).slice(1); }

  function brandsFromProducts(){
    var map = {};
    DATA.p.forEach(function(prod){
      (prod.tg || []).forEach(function(t){
        if(t.indexOf(BRAND_PREFIX) === 0){
          var h = t.slice(BRAND_PREFIX.length);
          if(!map[h]) map[h] = (DATA.cm && DATA.cm[h]) || capWord(h);
        }
      });
    });
    return map;
  }

  // Modellname: nur die Fahrzeugbezeichnung — Titelpräfix weg, alles vor dem
  // Trenner weg ("… – BMW M2 (G87) S58"), führenden Markennamen weg.
  function modelLabel(prod, brandName){
    var t = String(prod.t || '');
    if(STRIP && t.indexOf(STRIP) === 0) t = t.slice(STRIP.length);
    t = t.replace(/^\s+/, '');
    if(SPLIT_AT && t.indexOf(SPLIT_AT) > -1){
      t = t.slice(t.indexOf(SPLIT_AT) + SPLIT_AT.length).replace(/^\s+/, '');
    }
    var bn = String(brandName || '');
    if(bn){
      var first = t.split(' ')[0] || '';
      // Deckt auch abweichende Schreibweisen ab: "Mercedes" -> "Mercedes-Benz"
      if(first && first.toLowerCase().indexOf(bn.toLowerCase().slice(0, 4)) === 0 &&
         first.length <= bn.length + 8){
        t = t.slice(first.length).replace(/^\s+/, '');
      }
    }
    return t.replace(/\s+$/, '');
  }

  // Produkt-Modus: gewähltes Fahrzeug und die Modell-Kennung je Produkt
  var MODELS = {}, PMODEL = '', PBRAND = '';

  function brandHandleOf(prod){
    var tg = prod.tg || [];
    for(var bi=0; bi<tg.length; bi++){
      if(tg[bi].indexOf(BRAND_PREFIX) === 0) return tg[bi].slice(BRAND_PREFIX.length);
    }
    return '';
  }

  function modelKeyOf(prod){
    if(prod.__mkey != null) return prod.__mkey;
    if(!modelKeyOf.__map) modelKeyOf.__map = brandsFromProducts();
    var m = modelKeyOf.__map;
    prod.__mkey = slug(modelLabel(prod, m[brandHandleOf(prod)] || ''));
    return prod.__mkey;
  }

  function setProductVehicle(brandHandle, key, push){
    var o = MODELS[key];
    if(!o) return;
    PBRAND = brandHandle || ''; PMODEL = key;
    var map = brandsFromProducts();
    var bn = map[PBRAND] || (PBRAND ? capWord(PBRAND) : '');
    show('[data-cpk-vehpick]', false); show('[data-cpk-vehon]', true);
    setText('[data-cpk-vehname]', (bn ? bn + ' ' : '') + o.t);
    setText('[data-cpk-vehmeta]', o.n === 1 ? '1 passendes Teil' : o.n + ' passende Teile');
    writeUrl(!!push);
    apply();
  }

  function clearProductVehicle(push){
    PMODEL = ''; PBRAND = '';
    show('[data-cpk-vehon]', false); show('[data-cpk-vehpick]', true);
    writeUrl(!!push);
    apply();
  }

  function fillBrandsFromProducts(){
    var bs = root.querySelector('[data-cpk-brand]');
    if(!bs) return;
    var map = brandsFromProducts();
    var keys = Object.keys(map).sort(function(a,b){ return map[a].localeCompare(map[b], 'de'); });
    var cur = bs.value;
    bs.innerHTML = '<option value="">Marke wählen</option>' + keys.map(function(h){
      return '<option value="' + esc(h) + '">' + esc(map[h]) + '</option>';
    }).join('');
    var want = cur;
    if(PAGE_BRAND && map[PAGE_BRAND]){ want = PAGE_BRAND; bs.hidden = true; }
    else if(!want && brandGroup){
      var sel = state.sel[brandGroup.dataset.key] || [];
      if(sel.length === 1 && map[sel[0]]) want = sel[0];
    }
    if(want && map[want]) bs.value = want;
    fillModels(bs.value, map);
  }

  // Modell-Liste: jedes Fahrzeug genau einmal, mit Anzahl der passenden Teile
  function fillModels(brand, map){
    var ms = root.querySelector('[data-cpk-model]');
    if(!ms) return;
    map = map || brandsFromProducts();
    modelKeyOf.__map = map;
    var cur = ms.value;
    var seen = {}, order = [];
    if(brand){
      DATA.p.forEach(function(prod){
        if((prod.tg || []).indexOf(BRAND_PREFIX + brand) < 0) return;
        var lab = modelLabel(prod, map[brand]);
        if(!lab) return;
        var k = slug(lab);
        if(!k) return;
        if(!seen[k]){ seen[k] = { t:lab, u:prod.u, n:0 }; order.push(k); }
        seen[k].n++;
      });
      order.sort(function(a,b){ return seen[a].t.localeCompare(seen[b].t, 'de', { numeric:true }); });
    }
    MODELS = seen;
    ms.innerHTML = '<option value="">' + (brand ? 'Modell wählen' : 'Erst Marke wählen') + '</option>' +
      order.map(function(k){
        var o = seen[k];
        var suffix = o.n > 1 ? '  ·  ' + o.n + ' Teile' : '';
        return '<option value="' + esc(k) + '">' + esc(o.t + suffix) + '</option>';
      }).join('') +
      (loading && brand ? '<option value="" disabled>… weitere werden geladen</option>' : '');
    ms.disabled = !brand || !order.length;
    if(cur && seen[cur]){ ms.value = cur; }
    toggleGo();
  }

  function bindProductsMode(){
    var bs = root.querySelector('[data-cpk-brand]'), ms = root.querySelector('[data-cpk-model]');
    if(!bs || !ms) return;
    vehBox.hidden = false;
    fillBrandsFromProducts();
    bs.addEventListener('change', function(){
      fillModels(bs.value);
      // Raster gleich auf die Marke einschränken, wenn es eine Marken-Filtergruppe gibt
      if(brandGroup && !PAGE_BRAND){
        state.sel[brandGroup.dataset.key] = bs.value ? [slug(bs.value)] : [];
        writeUrl(false); apply();
      }
    });
    ms.addEventListener('change', toggleGo);

    // Fahrzeug aus der Adresse wiederherstellen (?marke=bmw&modell=m2-g87-s58)
    var wantM = fromUrl.modell ? slug(fromUrl.modell) : '';
    if(wantM){
      var wantB = fromUrl.marke ? slug(fromUrl.marke) : (bs.value || PAGE_BRAND || '');
      if(wantB && bs.value !== wantB) bs.value = wantB;
      fillModels(bs.value);
      if(MODELS[wantM]){ ms.value = wantM; setProductVehicle(bs.value, wantM, false); }
    }
  }

  function toggleGo(){
    var bs = root.querySelector('[data-cpk-brand]'), ms = root.querySelector('[data-cpk-model]');
    var go = root.querySelector('[data-cpk-vehgo]');
    if(go) go.disabled = !(bs && bs.value && ms && ms.value);
  }

  /* ---------- Ereignisse ---------- */
  root.addEventListener('click', function(e){
    var t = e.target;
    var head = t.closest && t.closest('.cpk__ghead');
    if(head){
      var g = head.parentNode;
      var open = g.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var dot = t.closest && t.closest('[data-cpk-color]');
    if(dot){
      var dcard = dot.closest('[data-cpk-card]');
      if(dcard){
        dcard.__color = (dcard.__color === dot.dataset.cpkColor) ? null : dot.dataset.cpkColor;
        apply();
      }
      return;
    }
    var val = t.closest && t.closest('.cpk__val');
    if(val){
      if(val.getAttribute('aria-disabled') === 'true') return;
      var grp = val.closest('[data-cpk-group]'), key = grp.dataset.key, v = val.dataset.v;
      var list = state.sel[key] || (state.sel[key] = []);
      var at = list.indexOf(v);
      if(at > -1) list.splice(at,1); else list.push(v);
      writeUrl(false); apply();
      return;
    }
    var av = t.closest && t.closest('[data-cpk-avail]');
    if(av){
      state.avail = !state.avail;
      av.setAttribute('aria-pressed', state.avail ? 'true' : 'false');
      writeUrl(false); apply();
      return;
    }
    var chip = t.closest && t.closest('[data-chip]');
    if(chip){
      if(chip.dataset.key === 'lager'){
        state.avail = false;
        var sw = root.querySelector('[data-cpk-avail]'); if(sw) sw.setAttribute('aria-pressed','false');
      } else {
        var l = state.sel[chip.dataset.key] || [];
        var idx = l.indexOf(chip.dataset.v);
        if(idx > -1) l.splice(idx,1);
      }
      writeUrl(false); apply();
      return;
    }
    if(t.closest && (t.closest('[data-cpk-reset]') || t.closest('[data-cpk-reset2]'))){
      groups.forEach(function(g){ state.sel[g.dataset.key] = []; });
      state.avail = false;
      var sw2 = root.querySelector('[data-cpk-avail]'); if(sw2) sw2.setAttribute('aria-pressed','false');
      if(state.veh) clearVehicle(false); else { writeUrl(true); apply(); }
      return;
    }
    if(t.closest && t.closest('[data-cpk-vehgo]')){
      var bs = root.querySelector('[data-cpk-brand]'), ms = root.querySelector('[data-cpk-model]');
      if(vehMode === 'products'){
        var mkey = ms && ms.value;
        if(!mkey) return;
        var mo = MODELS[mkey];
        // Genau ein Teil für dieses Fahrzeug: direkt dorthin, sonst Raster filtern
        if(mo && mo.n === 1 && mo.u){ window.location.href = mo.u; return; }
        setProductVehicle(bs ? bs.value : '', mkey, true);
        return;
      }
      if(bs && ms && bs.value && ms.value) setVehicle(bs.value, ms.value, true);
      return;
    }
    if(t.closest && t.closest('[data-cpk-vehchange]')){
      if(vehMode === 'products'){ clearProductVehicle(true); return; }
      show('[data-cpk-vehon]', false); show('[data-cpk-vehpick]', true);
      return;
    }
    if(t.closest && t.closest('[data-cpk-vehclear]')){
      if(vehMode === 'products'){ clearProductVehicle(true); return; }
      clearVehicle(true); return;
    }
    if(t.closest && t.closest('[data-cpk-vehmemogo]')){
      try {
        var m = JSON.parse(localStorage.getItem(STORE) || 'null');
        if(m) setVehicle(m.marke, m.modell, true);
      } catch(e){}
      return;
    }
    if(t.closest && t.closest('[data-cpk-vehmemoclear]')){
      try { localStorage.removeItem(STORE); } catch(e){}
      show('[data-cpk-vehmemo]', false); show('[data-cpk-vehpick]', true);
      return;
    }
    if(t.closest && t.closest('[data-cpk-dens]')){
      var btn = t.closest('[data-cpk-dens]');
      root.style.setProperty('--cpk-cols', btn.dataset.cpkDens);
      Array.prototype.forEach.call(root.querySelectorAll('[data-cpk-dens]'), function(b){
        b.classList.toggle('is-on', b === btn);
      });
      return;
    }
    if(t.closest && t.closest('[data-cpk-open]')){ openSide(true); return; }
    if(t.closest && (t.closest('[data-cpk-close]') || t.closest('[data-cpk-close2]') || t.closest('[data-cpk-scrim]'))){
      openSide(false); return;
    }
  });

  root.addEventListener('change', function(e){
    if(e.target && e.target.hasAttribute && e.target.hasAttribute('data-cpk-sort')){
      state.sort = e.target.value;
      writeUrl(false); apply();
    }
  });

  var lastFocus = null;
  function openSide(on){
    root.classList.toggle('cpk--open', on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
    var side = root.querySelector('[data-cpk-side]');
    if(on){ lastFocus = document.activeElement; if(side) side.focus({preventScroll:true}); }
    else if(lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && root.classList.contains('cpk--open')) openSide(false);
  });

  window.addEventListener('popstate', function(){
    var v = readUrl();
    if(v.marke && FIT){
      var b = H ? H.resolveBrand(FIT, v.marke) : null;
      var m = b && H ? H.resolveModel(FIT, b, v.modell) : null;
      if(b && m) setVehicle(b, m, false); else clearVehicle(false);
    } else if(state.veh) clearVehicle(false);
    else apply();
  });

  /* ---------- Weitere Seiten im Hintergrund nachladen (Section Rendering API) ---------- */
  function loadRest(){
    if(root.dataset.loadAll !== '1' || !grid || !window.fetch || !window.DOMParser) return;
    var pages = parseInt(grid.dataset.pages || '1', 10), cur = parseInt(grid.dataset.page || '1', 10);
    var total = parseInt(grid.dataset.total || '0', 10);
    var sid = root.dataset.sectionId, base = root.dataset.collectionUrl || window.location.pathname;
    if(!(pages > 1) || !sid) return;
    var note = root.querySelector('[data-cpk-loadnote]');
    var seen = {};
    cards.forEach(function(c){ seen[c.dataset.handle] = 1; });
    var pending = [];
    for(var p = 1; p <= pages; p++) if(p !== cur) pending.push(p);
    loading = true;
    LOAD_TOTAL = total;
    apply(); // Gesamtzahl sofort anzeigen

    // Hinweis nur gedrosselt aktualisieren – die sichtbaren Karten bleiben unverändert stehen
    var noteTimer = null;
    function setNote(done){
      if(!note) return;
      if(done){ if(noteTimer){ clearTimeout(noteTimer); noteTimer = null; } note.hidden = true; return; }
      if(noteTimer) return;
      noteTimer = setTimeout(function(){
        noteTimer = null;
        if(!loading) return;
        note.hidden = false;
        note.textContent = 'Lade weitere Modelle … ' + fmtNum(cards.length) + (total ? ' von ' + fmtNum(total) : '');
      }, 400);
    }
    // Neue Karten werden versteckt angehängt und erst am Ende einmal einsortiert
    function absorb(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var js = doc.querySelector('[data-cpk-data]');
      if(js){
        try {
          var extra = JSON.parse(js.textContent);
          (extra.p || []).forEach(function(prod){
            if(!byHandle[prod.h]){ byHandle[prod.h] = prod; DATA.p.push(prod); }
          });
        } catch(e){}
      }
      var list = doc.querySelectorAll('[data-cpk-card]');
      var frag = document.createDocumentFragment();
      for(var i = 0; i < list.length; i++){
        var h = list[i].getAttribute('data-handle');
        if(seen[h]) continue;
        seen[h] = 1;
        var el = document.importNode(list[i], true);
        el.hidden = true;
        frag.appendChild(el);
        cards.push(el);
      }
      grid.appendChild(frag);
    }
    function finish(ok){
      loading = false;
      setNote(true);
      buildValues();
      apply();
      if(ok){
        var pager = root.querySelector('.cpk__pager'); if(pager) pager.hidden = true;
        var pn = root.querySelector('.cpk__pagenote'); if(pn) pn.hidden = true;
      }
      if(vehMode === 'products') fillBrandsFromProducts();
    }
    setNote(false);

    // Mehrere Seiten gleichzeitig abrufen (begrenzt), statt eine nach der anderen
    var CONC = 4, idx = 0, running = 0, failed = false, done = 0;
    function pump(){
      while(running < CONC && idx < pending.length){
        (function(pg){
          running++;
          fetch(base + '?section_id=' + encodeURIComponent(sid) + '&page=' + pg, { credentials:'same-origin' })
            .then(function(r){ if(!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
            .then(function(html){ absorb(html); })
            .catch(function(e){
              failed = true;
              if(window.console) console.warn('[cp-category] Nachladen fehlgeschlagen (Seite ' + pg + '):', e);
            })
            .then(function(){
              running--; done++;
              setNote(false);
              if(done >= pending.length) finish(!failed);
              else pump();
            });
        })(pending[idx++]);
      }
    }
    pump();
  }

  /* ---------- Weitere ansehen / Weniger anzeigen ---------- */
  // Begrenzt die sichtbaren Treffer per Klasse (nicht über hidden, das gehört der Filterlogik).
  var moreBox = root.querySelector('[data-cpk-more]');
  var moreInfo = moreBox && moreBox.querySelector('[data-cpk-more-info]');
  var moreBar  = moreBox && moreBox.querySelector('[data-cpk-more-bar]');
  var moreBtn  = moreBox && moreBox.querySelector('[data-cpk-more-btn]');
  var lessBtn  = moreBox && moreBox.querySelector('[data-cpk-less-btn]');
  var moreMq   = window.matchMedia ? window.matchMedia('(max-width: 860px)') : null;
  var LIMIT = 0, capSig = null;

  function moreStep(){
    if(!moreBox) return 0;
    var m = moreMq && moreMq.matches;
    return parseInt(m ? moreBox.dataset.initM : moreBox.dataset.initD, 10) || 24;
  }
  function visibleCards(){
    var out = [];
    if(!grid) return out;
    for(var k = 0; k < grid.children.length; k++){
      var c = grid.children[k];
      if(c.hasAttribute('data-cpk-card') && !c.hidden) out.push(c);
    }
    return out;
  }
  function capCards(){
    if(!moreBox || !grid) return;
    var step = moreStep();
    // Neue Filter-/Sortier-/Fahrzeugauswahl: wieder bei der Startanzahl beginnen
    var sig = '';
    try { sig = JSON.stringify([state.sel, state.avail, state.sort, state.veh, typeof PMODEL !== 'undefined' ? PMODEL : null]); } catch(e){}
    if(sig !== capSig){ capSig = sig; LIMIT = step; }
    if(!LIMIT) LIMIT = step;

    var vis = visibleCards();
    var total = vis.length;
    for(var k = 0; k < cards.length; k++) cards[k].classList.remove('is-capped');
    for(var j = LIMIT; j < total; j++) vis[j].classList.add('is-capped');

    if(total <= step){ moreBox.hidden = true; return; }
    var shownN = Math.min(LIMIT, total);
    moreBox.hidden = false;
    if(moreInfo) moreInfo.innerHTML = '<b>' + shownN + '</b> von ' + total + ' Produkten';
    if(moreBar) moreBar.style.width = Math.round(shownN / total * 1000) / 10 + '%';
    if(moreBtn) moreBtn.hidden = shownN >= total;
    if(lessBtn) lessBtn.hidden = LIMIT <= step;
  }
  if(moreBtn) moreBtn.addEventListener('click', function(){
    var before = LIMIT;
    LIMIT += moreStep();
    capCards();
    var first = visibleCards()[before];
    var link = first && first.querySelector('a[href]');
    if(link && link.focus) link.focus({ preventScroll:true });
  });
  if(lessBtn) lessBtn.addEventListener('click', function(){
    LIMIT = moreStep();
    capCards();
    if(grid){
      var top = grid.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 140;
      try { window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' }); } catch(e){ window.scrollTo(0, Math.max(0, top)); }
    }
  });
  if(moreMq){
    var onMq = function(){ LIMIT = moreStep(); capCards(); };
    if(moreMq.addEventListener) moreMq.addEventListener('change', onMq);
    else if(moreMq.addListener) moreMq.addListener(onMq);
  }

  /* ---------- Start ---------- */
  buildValues();
  var fromUrl = readUrl();
  apply();
  loadRest();

  if(vehBox && vehMode === 'products'){
    bindProductsMode();
  } else if(vehBox){
    var boot = function(){
      var url = root.dataset.fitment;
      var loader = (window.CPFitment && window.CPFitment.load)
        ? window.CPFitment.load(url)
        : fetch(url, { credentials:'same-origin' }).then(function(r){ return r.json(); });
      loader.then(function(json){
        FIT = json;
        H = window.CPFitment || H;
        vehBox.hidden = false;
        fillBrands();
        if(fromUrl.marke){
          var b = H ? H.resolveBrand(FIT, fromUrl.marke) : null;
          var m = b && H ? H.resolveModel(FIT, b, fromUrl.modell) : null;
          if(b && m){ setVehicle(b, m, false); return; }
        }
        try {
          var memo = JSON.parse(localStorage.getItem(STORE) || 'null');
          if(memo && memo.marke && FIT.f[memo.marke] && FIT.f[memo.marke][memo.modell]){
            setText('[data-cpk-vehmemoname]', memo.marke + ' ' + memo.modell);
            show('[data-cpk-vehpick]', false);
            show('[data-cpk-vehmemo]', true);
          }
        } catch(e){}
        apply();
      }).catch(function(){ vehBox.hidden = true; });
    };
    if(window.CPFitment) boot();
    else window.addEventListener('DOMContentLoaded', boot);
  }
})();
